export default "__VITE_ASSET__fe3a5a7a__"